import styled from 'styled-components';

const StyledLink = styled('a')`
  text-decoration: none;
`;

export default StyledLink;
